module.exports = __webpack_public_path__ + "static/o-projektech-top-05d706f0dfb1546cc41390272564529b.png";